import React from 'react';
import { motion } from 'framer-motion';
// Apni image ka path yahan sahi karein
import Be1 from '../assets/images/Be1.png'; 
import Be2 from '../assets/images/Be2.png'; 

const Be = () => {
  return (
    <section className="bg-bggraycolor py-10 lg:py-20 px-4 sm:px-6 overflow-hidden">
      <div className="container ml-auto max-w-7xl">
        
        {/* Main Banner */}
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative bg-bgcolor rounded-[3rem] min-h-[500px] flex flex-col lg:flex-row items-center overflow-hidden shadow-2xl"
        >
          
          {/* Left Side White Soft Gradient - Bilkul image jesa */}
          <div className="absolute top-0 left-0 w-1/2 h-full  to-transparent pointer-events-none z-10"></div>

          {/* Left Content Section */}
          <div className="w-full lg:w-1/2 p-10 lg:p-20 z-20 text-center lg:text-left">
            <motion.h2 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="text-white text-4xl md:text-6xl font-bold leading-tight mb-6 tracking-tight"
            >
              Be the Reason <br /> Someone Smiles Today!
            </motion.h2>
            
            <motion.p 
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-white/90 text-lg md:text-xl max-w-md mb-10 leading-relaxed font-medium"
            >
              Your generosity can change lives every donation brings hope, support, and a brighter future. Give today and make a difference!
            </motion.p>

            <motion.button 
              whileHover={{ scale: 1.05 }}
              className="bg-white text-bgcolor px-10 py-4 rounded-2xl font-bold text-lg shadow-xl"
            >
              Donate Now
            </motion.button>
          </div>

          {/* Right Side Image Section - Chipakwa (Pinned to edges) */}
          <div className="w-full lg:w-1/2 relative h-[350px] lg:h-full flex items-end justify-end self-end z-20">
            
            {/* Back Mobile (Slightly left) */}
            <div className="absolute right-[140px] md:left-1 bottom-[-20px] ">
              <img 
                src={Be1} 
                className="w-[180px] md:w-[260px]  rounded-t-[2.5rem] " 
                alt="Back View" 
              />
            </div>

            {/* Front Mobile (Right side chipakwa) */}
            <div className="absolute right-[-10px] md:right-10 bottom-[-40px]">
              <img 
                src={Be2} 
                className="w-[220px] md:w-[320px] drop-shadow-[0_25px_50px_rgba(0,0,0,0.4)] rounded-t-[3rem]" 
                alt="Front View" 
              />
            </div>
          </div>

        </motion.div>
      </div>
    </section>
  );
};

export default Be;